var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHtlForestViewFilled = function SvgHtlForestViewFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2.5 14a.5.5 0 0 1 0-1H6v-1.449H2.5a.5.5 0 0 1-.418-.776l2.1-3.185h-.958a.5.5 0 0 1-.411-.786l3.189-4.59a.5.5 0 0 1 .818-.004l1.725 2.421.951-1.368a.5.5 0 0 1 .637-.16.5.5 0 0 1 .178.155l2.87 4.028a.5.5 0 0 1-.408.789h-.732l1.815 2.7a.5.5 0 0 1-.415.78h-2.948V13h3a.5.5 0 0 1 0 1H2.5Zm7-1v-1.449H7V13h2.5Z"
  })));
};
export default SvgHtlForestViewFilled;